import { render, staticRenderFns } from "./ClassDiaryHub.vue?vue&type=template&id=11f545ca"
import script from "./ClassDiaryHub.vue?vue&type=script&lang=js"
export * from "./ClassDiaryHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11f545ca')) {
      api.createRecord('11f545ca', component.options)
    } else {
      api.reload('11f545ca', component.options)
    }
    module.hot.accept("./ClassDiaryHub.vue?vue&type=template&id=11f545ca", function () {
      api.rerender('11f545ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/ClassDiaryHub.vue"
export default component.exports